import "core-js/modules/es6.object.assign";
import "antd/lib/input/style/css";
import _Input from "antd/lib/input";
import "core-js/modules/es6.function.name";
import * as tslib_1 from "tslib";
import { Field } from "formik";
import * as React from "react";
export var Input = function Input(_a) {
  var name = _a.name,
      validate = _a.validate,
      restProps = tslib_1.__rest(_a, ["name", "validate"]);

  return React.createElement(Field, {
    name: name,
    validate: validate
  }, function (_ref) {
    var _ref$field = _ref.field,
        value = _ref$field.value,
        onChange = _ref$field.onChange,
        onBlur = _ref$field.onBlur;
    return React.createElement(_Input, Object.assign({
      name: name,
      value: value,
      onChange: onChange,
      onBlur: onBlur
    }, restProps));
  });
};

Input.Password = function (_a) {
  var name = _a.name,
      validate = _a.validate,
      restProps = tslib_1.__rest(_a, ["name", "validate"]);

  return React.createElement(Field, {
    name: name,
    validate: validate
  }, function (_ref2) {
    var _ref2$field = _ref2.field,
        value = _ref2$field.value,
        onChange = _ref2$field.onChange,
        onBlur = _ref2$field.onBlur;
    return React.createElement(_Input.Password, Object.assign({
      name: name,
      value: value,
      onChange: onChange,
      onBlur: onBlur
    }, restProps));
  });
};

Input.TextArea = function (_a) {
  var name = _a.name,
      validate = _a.validate,
      restProps = tslib_1.__rest(_a, ["name", "validate"]);

  return React.createElement(Field, {
    name: name,
    validate: validate
  }, function (_ref3) {
    var _ref3$field = _ref3.field,
        value = _ref3$field.value,
        onChange = _ref3$field.onChange,
        onBlur = _ref3$field.onBlur;
    return React.createElement(_Input.TextArea, Object.assign({
      name: name,
      value: value,
      onChange: onChange,
      onBlur: onBlur
    }, restProps));
  });
};